/* Prijzen zonder ",00", in de notatie van de taal.

   Waarom zo: de prijzen op de site komen in twee notaties binnen. Het thema
   schrijft "€2,820.00" (Engels), en op /nl maakt Weglot daar "€ 2.820,00"
   van, maar alleen voor prijzen die het ooit vertaald heeft. Prijzen die
   JavaScript later neerzet (variant kiezen, winkelwagen) blijven Engels.
   Een prijs in het thema veranderen kan niet: dat is voor Weglot een nieuwe
   zin, en met een vol woordenlimiet blijft die Engels. Op /nl zou dan
   "€2,820" staan, wat je leest als € 2,82.

   Dit script leest elke prijs met centen en schrijft hem opnieuw:
   /nl: €1.640  €67,50      elders: €1,640  €67.50
   Hele euro's verliezen ",00"; echte centen blijven staan.
   Prijzen zonder centen (zoals "€ 100,-" in het menu) blijven ongemoeid. */
(function () {
  if (window.__priceFormat) return; // niet twee keer draaien
  window.__priceFormat = true;
  var isNL = /^\/nl(\/|$)/.test(location.pathname);
  var THOUSANDS = isNL ? '.' : ',';
  var DECIMAL = isNL ? ',' : '.';
  // € + bedrag met duizendtallen (. of ,) + verplicht twee decimalen
  var PRICE = /€\s?(\d{1,3}(?:[.,]\d{3})+|\d+)([.,])(\d{2})(?!\d)/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };

  function format(text) {
    return text.replace(PRICE, function (match, euros, sep, cents) {
      var digits = euros.replace(/[.,]/g, '');
      var grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS);
      return '€' + grouped + (cents === '00' ? '' : DECIMAL + cents);
    });
  }

  function fixNode(node) {
    var value = node.nodeValue;
    if (!value || value.indexOf('€') === -1) return;
    var parent = node.parentNode;
    if (!parent || SKIP[parent.nodeName] || parent.isContentEditable) return;
    var next = format(value);
    if (next !== value) node.nodeValue = next; // alleen schrijven bij verschil: geen lussen met Weglot
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixNode(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) fixNode(node);
  }

  walk(document.body);

  // Kijkt naar het hele document, niet alleen <body>: op productpagina's
  // raakte een observer op <body> los, waardoor prijzen die JavaScript later
  // neerzet (variant kiezen, winkelwagen) oud bleven. Direct verwerken, zonder
  // requestAnimationFrame (die wacht in tabbladen die niet in beeld zijn).
  // Schrijven gebeurt alleen bij verschil, dus geen lus met Weglot.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'characterData') {
        fixNode(m.target);
      } else {
        for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  // Vangnet: opnieuw na volledig laden en nadat Weglot klaar is.
  window.addEventListener('load', function () { walk(document.body); });
  if (window.Weglot && typeof window.Weglot.on === 'function') {
    window.Weglot.on('initialized', function () { walk(document.body); });
  }
})();
